import { AnyAction } from 'redux';
import { submissionEnvironmentInitialState } from '@reducers/initialState/submissionEnvironment';
import { SubmissionEnvironmentState } from '@types';
import { submissionEnvironmentActionTypes } from '@actions/actionTypes/submissionEnvironment';

export const submissionEnvironmentReducer = (
  state = submissionEnvironmentInitialState,
  action: AnyAction
): SubmissionEnvironmentState => {
  switch (action.type) {
    case submissionEnvironmentActionTypes.SET_SUBMISSION_USER: {
      return { ...state, submissionUser: action.payload };
    }
    case submissionEnvironmentActionTypes.SET_EMPLOYEE_NUMBER: {
      return { ...state, employeeNumber: action.payload };
    }
    case submissionEnvironmentActionTypes.SET_SUBMISSION_CONTEXT: {
      return { ...state, context: action.payload };
    }

    case submissionEnvironmentActionTypes.SET_SUBMISSION_ATTACHMENTS: {
      return { ...state, attachments: action.payload };
    }

    case submissionEnvironmentActionTypes.SET_SUBMISSION_ATTACHMENTS_EXECUTED: {
      return { ...state, attachmentsExecuted: action.payload };
    }

    case submissionEnvironmentActionTypes.SET_SCALE: {
      return { ...state, scale: action.payload };
    }

    case submissionEnvironmentActionTypes.SET_RENDERER_WIDTH: {
      return { ...state, rendererWidth: action.payload };
    }

    case submissionEnvironmentActionTypes.SET_SUBMISSION_DOWNLOAD: {
      return { ...state, isDownload: action.payload };
    }

    case submissionEnvironmentActionTypes.SET_SUBMISSION_LANGUAGE: {
      return { ...state, lang: action.payload };
    }

    default: {
      return state;
    }
  }
};
